import type { AdminClientContext, AdminHttpClient } from './client.js';
import type { ListQuery } from '../../../shared-types/src/index.js';

type MethodKeys =
  | 'getTenants'
  | 'createTenant'
  | 'deleteTenant'
  | 'transferTenantPartner'
  | 'actAsTenant'
  | 'setTenantCustomModels'
  | 'setTenantMcpConnectors'
  | 'setTenantDeepAgentApprovalTools'
  | 'getTenantMcpConnectors'
  | 'getOwnMcpConnectors';

export function buildTenantsMethods(ctx: AdminClientContext) {
  const { transport, token, idemKey } = ctx;

  return {
    getTenants: ((query?: ListQuery) =>
      query
        ? transport.listTenants(token(), query)
        : transport.listTenants(token())) as AdminHttpClient['getTenants'],
    createTenant: (input, idempotencyKey) =>
      transport.createTenant(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    deleteTenant: (tenantId, confirmName, idempotencyKey) =>
      transport.deleteTenant(token(), {
        tenantId,
        confirmName,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    transferTenantPartner: (tenantId, input, idempotencyKey) =>
      transport.transferTenantPartner(token(), {
        tenantId,
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    actAsTenant: (tenantId) => transport.actAsTenant(token(), tenantId),
    setTenantCustomModels: (tenantId, allowCustomModels, idempotencyKey) =>
      transport.setTenantCustomModels(token(), {
        tenantId,
        allowCustomModels,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    setTenantMcpConnectors: (tenantId, activeMcpConnectors, idempotencyKey) =>
      transport.setTenantMcpConnectors(token(), {
        tenantId,
        activeMcpConnectors,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    setTenantDeepAgentApprovalTools: (
      tenantId,
      deepAgentApprovalTools,
      idempotencyKey
    ) =>
      transport.setTenantDeepAgentApprovalTools(token(), {
        tenantId,
        deepAgentApprovalTools,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    getTenantMcpConnectors: (tenantId) =>
      transport.getTenantMcpConnectors(token(), tenantId),
    getOwnMcpConnectors: () => transport.getOwnMcpConnectors(token()),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
